module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.href) ? _c('a', {
    directives: [{
      name: "md-ink-ripple",
      rawName: "v-md-ink-ripple"
    }],
    staticClass: "md-bottom-bar-item",
    class: _vm.classes,
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.mdIcon))]), _vm._v(" "), _c('span', {
    staticClass: "md-text"
  }, [_vm._t("default")], true)]) : _c('button', {
    directives: [{
      name: "md-ink-ripple",
      rawName: "v-md-ink-ripple"
    }],
    staticClass: "md-bottom-bar-item",
    class: _vm.classes,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.mdIcon))]), _vm._v(" "), _c('span', {
    staticClass: "md-text"
  }, [_vm._t("default")], true)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c07f8a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c07f8a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mdBottomBar/mdBottomBarItem.vue
// module id = 21
// module chunks = 2 26